import { useEffect } from 'react'
import MessageLabel from '../../../../components/CommonComponents/MessageLabel'
import { useState } from 'react'
import { useMyContext } from '../../../../components/Provider/CommonProvider'
import MessageHeading from '../../../../components/CommonComponents/MessageHeading'
import MessageBox from '../../../../components/CommonComponents/MessageBox'
import MessageSubHeading from '../../../../components/CommonComponents/MessageSubHeading'
import AdminCustomButton from '../../../../components/CommonComponents/AdminCustomButton'
import { toast } from 'react-toastify'
import AdminDeleteModal from '../../../../components/CommonComponents/AdminDeleteModal'

const TranscodingJobs = () => {
    const { fetchRequest } = useMyContext()
    const baseURL = process.env.REACT_APP_Baseurl
    const [data, setData] = useState({})
    const [status, setStatus] = useState('active')
    const [withOutRefresh, setWithOutRefresh] = useState(false)

    const jobApi = `${baseURL}/admin/active-job`
    const moveFailedApi = `${baseURL}/admin/remove-active-job`
    const retryApi = `${baseURL}/admin/retry-job`

    const handleMoveFailed = async (id) => {
        const response = await fetchRequest({
            method: 'POST',
            url: `${moveFailedApi}/${id}`,
            params: {},
            data: {}
        }).then((res) => {
            toast.success(res?.message)
            setWithOutRefresh((prev) => !prev)
        }).catch((error) => {
            toast.error(error?.response?.data?.message || error?.message)
        })
    }
    const handleRetryFailed = async (id) => {
        const response = await fetchRequest({
            method: 'POST',
            url: `${retryApi}/${id}`,
            params: {},
            data: {}
        }).then((res) => {
            toast.success(res?.message)
            setWithOutRefresh((prev) => !prev)
        }).catch((error) => {
            toast.error(error?.response?.data?.message || error?.message)
        })
    }

    useEffect(async () => {
        const response = await fetchRequest({
            method: 'GET',
            url: `${jobApi}`,
            params: { status },
            data: {}
        }).then((res) => {
            setData(res?.data)
            toast.success(res?.message)
        }).catch((error) => {
            toast.error(error?.response?.data?.message || error?.message)
        })

    }, [status, withOutRefresh])


    return (

        <div>
            <AdminDeleteModal />

            <div className='d-flex align-items-center flex-wrap'>
                <div className='col-3 p-3' onClick={() => setStatus("active")}>
                    <div className='theme-bg-color rounded-3 p-3'>
                        <MessageHeading className={"text-center"} text={"Active"} />
                        <MessageBox classname={"text-center d-block"} text={data?.[0]?.counts?.active ?? '-'}></MessageBox>
                    </div>
                </div>
                <div className='col-3 p-3' onClick={() => setStatus("waiting")}>
                    <div className='theme-bg-color rounded-3 p-3 '>
                        <MessageHeading className={"text-center"} text={"Waiting"} />
                        <MessageBox classname={"text-center d-block"} text={data?.[0]?.counts?.waiting ?? '-'}></MessageBox>
                    </div>
                </div>
                <div className='col-3 p-3' onClick={() => setStatus("completed")}>
                    <div className='theme-bg-color rounded-3 p-3 '>
                        <MessageHeading className={"text-center"} text={"Completed"} />
                        <MessageBox classname={"text-center d-block"} text={data?.[0]?.counts?.completed ?? '-'}></MessageBox>
                    </div>
                </div>
                <div className='col-3 p-3' onClick={() => setStatus("failed")}>
                    <div className='theme-bg-color rounded-3 p-3 '>
                        <MessageHeading className={"text-center"} text={"Failed"} />
                        <MessageBox classname={"text-center d-block"} text={data?.[0]?.counts?.failed ?? '-'}></MessageBox>
                    </div>
                </div>
            </div>

            <div className=''>
                {data?.[0]?.jobs.length ? data?.[0]?.jobs.map((item) => {
                    return <div>
                        <div className="mb-3 theme-bg-color rounded-3 p-3">
                            <div className='d-flex align-items-center justify-content-between'>
                                <MessageHeading text={`Job : ${item?.id}`} />
                                {status == "active" && <AdminCustomButton saveMethod={() => handleMoveFailed(item?.id)} saveText={"Move to Failed"} />}
                                {status == "failed" && <AdminCustomButton saveMethod={() => handleRetryFailed(item?.id)} saveText={"Retry"} />}

                            </div>
                            <div className="d-flex align-items-center flex-wrap  ">
                                <div className="col-3 position-relative">
                                    <MessageLabel text="Type" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={String(item?.data?.upload_type || "-")} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="VideoPath" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={item?.data?.videoPath} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="Resolution" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={item?.data?.resolutions?.map((item) => item?.name).join(", ")} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="outputDirectory" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={item?.data?.outputDirectory} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="videoId" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={String(item?.data?.videoId)} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="officialId" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={String(item?.data?.officialId || "-")} className={""} />
                                </div>
                                <div className="col-3 position-relative">
                                    <MessageLabel text="failedReason" className={""} />
                                </div>
                                <div className="col-1 position-relative">
                                    <MessageLabel text=":" className={""} />
                                </div>
                                <div className="col-8 position-relative">
                                    <MessageSubHeading text={String(item?.failedReason || "-")}  custom className={"opacity-75 admin-input-description warningColor"} />
                                </div>
                            </div>

                        </div>
                    </div>
                }) : `No ${status} job found`}
            </div>
        </div>
    )
}

export default TranscodingJobs
